import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { isFirefox, isSafari, isIE } from "react-device-detect";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const Filter = ({
  index,
  filter,
  onRemove,
  onUpdate,
  datasetsList,
  datasetsFieldsList,
  datasets
}) => {
  const { dataset, field, operator, value } = filter;
  const [fieldType, setFieldType] = useState(null);
  // const [valid, setValid] = useState(null);
  const [invalidDateTime, setInvalidDateTime] = useState(false);
  const [altValue, setAltValue] = useState();
  const fieldTypes = {
    number: [
      ["eq", "Equal to"],
      ["ne", "Not equal to"],
      ["gt", "Greater than"],
      ["lt", "Less than"],
      ["gte", "Greater than or equal to"],
      ["lte", "Less than or equal to"]
    ],
    string: [
      ["eq", "Equal to"],
      ["ne", "Not Equal to"],
      ["ilk", "Contains"],
      ["inlk", "Does not contain"]
      // ["lk", "Starts with "]
    ],
    timestamp: [
      // ["eq", "On"],
      ["lt", "Before"],
      ["lte", "Before or equal to"],
      ["gt", "After"],
      ["gte", "After or equal to"]
    ],
    date: [
      ["eq", "On"],
      ["lt", "Before"],
      ["lte", "Before or equal to"],
      ["gt", "After"],
      ["gte", "After or equal to"]
    ],
    boolean: [
      ["eq", "Equal to"],
      ["ne", "Not Equal to"]
    ]
  };
  const maxDate = moment()
    .add(100, "years")
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .format();

  const minDate = moment()
    .subtract(100, "years")
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .format();

  const handleDatasetChange = v => {
    const newFilter = {
      ...filter,
      ...{
        dataset: v,
        field: "",
        operator: "",
        value: ""
      }
    };
    onUpdate(newFilter);
  };

  const handleFieldChange = v => {
    const newFilter = {
      ...filter,
      ...{
        field: v,
        operator: "",
        value: ""
      }
    };
    onUpdate(newFilter);
  };

  const handleOperatorChange = v => {
    const newFilter = {
      ...filter,
      ...{
        operator: v,
        value: ""
      }
    };
    onUpdate(newFilter);
  };

  const handleValueChange = v => {
    const newFilter = {
      ...filter,
      ...{
        value: v
      }
    };
    onUpdate(newFilter);
  };

  const validateDateTime = timevalue => {
    if (
      timevalue !== "" &&
      typeof timevalue === "string" &&
      moment(timevalue, moment.ISO_8601, true).isValid() &&
      moment(timevalue).isBetween(minDate, maxDate)
    ) {
      handleValueChange(timevalue);
      setAltValue(timevalue);
      setInvalidDateTime(false);
    } else if (
      timevalue !== "" &&
      moment(timevalue, "MM/DD/YYYY hh:mm A", true).isValid() &&
      timevalue.isBetween(minDate, maxDate)
    ) {
      // safari, ie, firefox
      handleValueChange(timevalue.toISOString(true));
      setAltValue(timevalue);
      setInvalidDateTime(false);
    } else {
      handleValueChange(null);
      setInvalidDateTime(true);
      setAltValue(timevalue);
    }
  };

  const isValidDate = timevalue => {
    const validTimevalue =
      timevalue && timevalue.isBefore(moment(new Date(maxDate)));

    return validTimevalue;
  };

  useEffect(() => {
    if (datasetsFieldsList) {
      const currentField = datasetsFieldsList.filter(item => {
        return dataset === item.dataset && field === item.id;
      });
      setFieldType(currentField.length === 1 ? currentField[0].type : "");
    }
  }, [datasetsFieldsList, dataset, field]);

  // useEffect(() => {
  //   setValid(
  //     dataset !== "" && field !== "" && operator !== "" && !invalidDateTime
  //   );
  // }, [dataset, field, operator, value, invalidDateTime]);

  return (
    datasets && (
      <tr className="builder__filter">
        <td>
          <Input
            type="select"
            required
            value={dataset}
            onChange={e => handleDatasetChange(e.target.value)}
            invalid={dataset === ""}
            aria-label="Dataset"
          >
            <option value="" aria-label="Dataset Hidden" disabled hidden />
            {datasetsList &&
              datasetsList
                .sort((a, b) => {
                  if (a.title === b.title) return 0;
                  return a.title > b.title ? 1 : -1;
                })
                .map(item => {
                  if (datasets.includes(item.id)) {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    );
                  }
                  return false;
                })}
          </Input>
        </td>
        <td>
          <Input
            type="select"
            required
            value={field}
            onChange={e => handleFieldChange(e.target.value)}
            invalid={dataset !== "" && field === ""}
            disabled={dataset === ""}
            aria-label="Field"
          >
            <option value="" aria-label="Field Hidden" disabled hidden />
            {datasetsFieldsList &&
              datasetsFieldsList
                .sort((a, b) => {
                  if (a.alias === b.alias) return 0;
                  return a.alias > b.alias ? 1 : -1;
                })
                .map(item => {
                  if (dataset === item.dataset && datasets.includes(dataset)) {
                    return (
                      <option
                        key={item.id}
                        value={item.id}
                        data-type={item.type}
                      >
                        {item.alias}
                      </option>
                    );
                  }
                  return false;
                })}
          </Input>
        </td>
        <td>
          <Input
            type="select"
            required
            value={operator}
            onChange={e => handleOperatorChange(e.target.value)}
            invalid={field !== "" && operator === ""}
            disabled={field === "" && !fieldType}
            aria-label="Operator"
          >
            <option value="" aria-label="Operator Hidden" disabled hidden />
            {fieldType &&
              fieldTypes[fieldType].map(item => (
                <option key={item[1]} value={item[0]}>
                  {item[1]}
                </option>
              ))}
          </Input>
        </td>
        <td
          className={
            (isFirefox || isSafari || isIE) &&
            invalidDateTime &&
            operator !== ""
              ? "invalid-input"
              : undefined
          }
        >
          {!fieldType && (
            <Input
              type="text"
              value={value}
              onChange={e => handleValueChange(e.target.value)}
              disabled={operator === ""}
              aria-label="Value"
            />
          )}
          {fieldType && fieldType === "string" && (
            <Input
              type="text"
              value={value.replaceAll("%","")}
              onChange={e => handleValueChange(e.target.value)}
              disabled={operator === ""}
              aria-label="Value"
            />
          )}
          {fieldType && fieldType === "number" && (
            <Input
              type="number"
              value={value}
              onChange={e => handleValueChange(e.target.value)}
              disabled={operator === ""}
              aria-label="Value"
            />
          )}
          {fieldType &&
            fieldType === "timestamp" &&
            !isFirefox &&
            !isSafari &&
            !isIE && (
              <Input
                type="datetime-local"
                value={value}
                onChange={e => validateDateTime(e.target.value)}
                onBlur={e => validateDateTime(e.target.value)}
                invalid={invalidDateTime}
                disabled={operator === ""}
                aria-label="Value"
              />
            )}
          {fieldType &&
            fieldType === "timestamp" &&
            (isFirefox || isSafari || isIE) && (
              <Datetime
                value={altValue}
                initialValue={new Date()}
                onChange={validateDateTime}
                onClose={validateDateTime}
                isValidDate={isValidDate}
                inputProps={{
                  disabled: operator === "",
                  placeholder: "MM/DD/YYYY 00:00 AM"
                }}
                aria-label="Value"
              />
            )}
          {fieldType && fieldType === "date" && (
            <Input
              type="date"
              value={value}
              onChange={e => handleValueChange(e.target.value)}
              disabled={operator === ""}
              aria-label="Value"
            />
          )}
          {fieldType && fieldType === "boolean" && (
            <Input
              type="select"
              value={value}
              onChange={e => handleValueChange(e.target.value)}
              disabled={operator === ""}
              aria-label="Value"
            >
              <option
                value=""
                aria-label="Value Hidden"
                disabled
                selected
                hidden
              />
              <option value={1}>True</option>
              <option value={0}>False</option>
            </Input>
          )}
        </td>
        {/* <td>
          <Button
            className="builder__filter-add"
            type="button"
            block
            color="link"
            onClick={onAdd}
            aria-label="Value"
            disabled={!valid}
          >
            <FontAwesomeIcon icon={faPlusCircle} />
          </Button>
        </td> */}
        <td>
          <Button
            className="builder__filter-remove"
            type="button"
            block
            color="link"
            onClick={onRemove}
            aria-label="Value"
          >
            <FontAwesomeIcon icon={faMinusCircle} />
          </Button>
        </td>
      </tr>
    )
  );
};

Filter.propTypes = {
  index: PropTypes.number.isRequired,
  filter: PropTypes.shape({
    dataset: PropTypes.string,
    field: PropTypes.string,
    operator: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  datasetsList: PropTypes.array,
  datasetsFieldsList: PropTypes.array,
  datasets: PropTypes.array.isRequired
};

Filter.defaultProps = {
  datasetsList: null,
  datasetsFieldsList: null
};

export default Filter;
